import { TimelineQueryParams } from '@/types/post';
import { TimelineFilters } from '@/types/filter';

export type { TimelineFilters } from '@/types/filter';

export const buildTimelineParams = (
  filters: TimelineFilters & { offset?: number; limit?: number; type?: 'APPROVED' | 'REJECTED' }
): TimelineQueryParams => {
  const params: TimelineQueryParams = {}
  
  const stringFieldsToReplace = ['territories', 'contexts', 'topics', 'partners', 'sources']
  const specialMappings: Record<string, string> = {
    search: 'q'
  }

  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null) continue

    const paramKey = specialMappings[key] || key

    if (stringFieldsToReplace.includes(key) && typeof value === 'string') {
      params[paramKey as keyof TimelineQueryParams] = value.replace(/;/g, ',') as any
    } else if (key === 'favorited') {
      if (typeof value === 'boolean') {
        params.favorited = value
      }
    } else if (key === 'date_range' || key === 'start_date' || key === 'end_date') {
      params[paramKey as keyof TimelineQueryParams] = value as any
    } else {
      params[paramKey as keyof TimelineQueryParams] = value as any
    }
  }

  return params
}

